import React, { useState } from "react";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import useApiUrls from "../../useApiUrls";

const AddDqr = () => {
  const navigate = useNavigate();
  const { id, name } = useParams();
  const { getUrlByOperation, error: urlError } = useApiUrls();


  // State to hold form data
  const [formData, setFormData] = useState({
    dqrname: "",
    remark: "",
    active: true, // Added active state
  });

  // State to hold API response or error
  const [message, setMessage] = useState("");

  // const handleSubmit = async (e) => {
  //   e.preventDefault(); // Prevent the form from refreshing the page

  //   // const formDataToSend = new FormData();
  //   // formDataToSend.append("dqrname", formData.dqrname);
  //   // formDataToSend.append("remark", formData.remark);
  //   // formDataToSend.append("active", formData.active);

  //   try {
  //     await axios.post(
  //       "http://api.dqr-display-tms.eventum.co.in/api/DQROperation/Insert",
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data", // Ensure correct content type for form-data
  //         },
  //       }
  //     );
  //     setMessage("Catelog added successfully!");

  //     // Navigate to another page after 3 seconds
  //     setTimeout(() => {
  //       navigate("/dqr-image-list");
  //     }, 3000);
  //   } catch (error) {
  //     setMessage("Failed to add catelog.");
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the form from refreshing the page
   

    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }
    
    try {
      const CampaignInsert = getUrlByOperation("DQRInsert");   
      const response = await axios.post(
        CampaignInsert,
        formData,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );

      // Check if the API response indicates failure
      if (response.data && (response.data.isresponse === false || response.data.responsestatus === "FAIL")) {
        // Display the error message from the API
        setMessage(response.data.errormsg || "Failed to add DQR.");
        return;
      }

      setMessage("Campaign added successfully!");

      setTimeout(() => {
        navigate("/dqr-image-list");
      }, 3000);

      // Navigate to campaign list after successful addition
    } catch (error) {
      setMessage("Failed to add campaign.");
    }
  };

  // Handle input change for text and file inputs separately
  const handleChange = (e) => {
    const { name, value, files, type } = e.target;

    if (type === "file") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: files[0], // Save single file if it's a file input
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value, // Save text input value
      }));
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">Add DQR </h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.dqrname}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="dqrname"
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Description</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.remark}
                                onChange={handleChange}
                                placeholder="Enter ..."
                                name="remark"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Active</label>
                              <select
                                className="form-control"
                                name="active"
                                value={formData.active}
                                onChange={handleChange}
                              >
                                <option value={true}>Active</option>
                                <option value={false}>Deactive</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="form-footer">
                          <button
                            type="submit"
                            id="add-sub"
                            className="btn btn-info"
                          >
                            Add
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {message && (
        <>
          <svg style={{ display: "none" }}>
            <symbol id="check-circle-fill" fill="currentColor" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </symbol>
            <symbol id="exclamation-triangle-fill" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
            </symbol>
          </svg>

          <div
            style={{
              position: "fixed",
              top: "20px",
              right: "10px",
              width: "25%",
              zIndex: "9999",
            }}
          >
            <div
              className={`alert d-flex align-items-center ${
                message.includes("successfully") ? "alert-success" : "alert-danger"
              }`}
              role="alert"
              style={{ marginBottom: "10px" }}
            >
              <svg
                className="bi flex-shrink-0 me-2"
                width="24"
                height="24"
                role="img"
                aria-label={message.includes("successfully") ? "Success:" : "Danger:"}
              >
                <use
                  href={
                    message.includes("successfully")
                      ? "#check-circle-fill"
                      : "#exclamation-triangle-fill"
                  }
                />
              </svg>
              &nbsp;
              <div>{message}</div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AddDqr;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

